import React, { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import { me, login } from "../../api/auth";

const AdminLayout = () => {
    const [mode, setMode] = useState("checking");
    const [user, setUser] = useState(null);

    const [form, setForm] = useState({ username: "", password: "" });
    const [error, setError] = useState(null);

    async function loadMe() {
        const u = await me();
        const role = String(u?.role || "");
        const isAdmin = role === "ADMIN" || role === "ROLE_ADMIN";
        if (!isAdmin) {
            throw new Error("У вас немає прав адміністратора");
        }
        setUser(u);
        setMode("admin");
    }

    useEffect(() => {
        (async () => {
            try {
                await loadMe();
            } catch (e) {
                setMode("login");
            }
        })();
    }, []);

    async function onSubmit(e) {
        e.preventDefault();
        setError(null);

        try {
            await login(form.username, form.password);
            await loadMe();
        } catch (e2) {
            const msg =
                e2?.response?.data?.error ||
                e2?.response?.data ||
                e2?.message ||
                "Помилка входу";
            setError(String(msg));
            setMode("login");
        }
    }

    if (mode === "checking") {
        return <div style={{ padding: 24 }}>Перевірка...</div>;
    }

    if (mode === "login") {
        return (
            <div style={{ padding: 24, maxWidth: 360 }}>
                <h2>Вхід (адмінка)</h2>
                {error && <div style={{ color: "red", marginBottom: 12 }}>{error}</div>}

                <form onSubmit={onSubmit} style={{ display: "grid", gap: 10 }}>
                    <input
                        placeholder="Логін"
                        value={form.username}
                        onChange={(e) => setForm((p) => ({ ...p, username: e.target.value }))}
                    />
                    <input
                        placeholder="Пароль"
                        type="password"
                        value={form.password}
                        onChange={(e) => setForm((p) => ({ ...p, password: e.target.value }))}
                    />
                    <button type="submit">Увійти</button>
                </form>
            </div>
        );
    }

    return (
        <div style={{ padding: 24 }}>
            <h2>Керування контентом</h2>
            <div style={{ marginBottom: 12 }}>
                Ви увійшли як: <b>{user?.username}</b> ({user?.role})
            </div>

            <Outlet context={{ user }} />
        </div>
    );
};

export default AdminLayout;
